import Link from 'next/link'
import { BardFlchButton as BardFlchButtonType } from '@/src/@types/statamic'
import Button from '@/src/components/core/Button'

export default function BardFlchButton({
  link,
  button_text,
  style,
}: BardFlchButtonType) {
  return (
    <div>
      <Button
        as={Link}
        href={link.url}
        version={style?.value === 'secondary' ? 'gray-outlined' : 'blue'}
      >
        {button_text}
      </Button>
    </div>
  )
}
